module.exports = __webpack_public_path__ + "static/media/flameSvg.ccae098c.svg";